import { ArpsDesignerKind, ProductNames } from "constants/forecasts.constants";

export type TypeWellProductItem = {
  label: string;
  key: string;
  type?: string;
};

const typeWellAndForecastProducts = [
  {
    label: "Oil",
    key: ProductNames.Oil
  },
  {
    label: "Condensate",
    key: ProductNames.Condensate
  },
  {
    label: "Gas",
    key: ProductNames.Gas
  },
  {
    label: "Sales Gas",
    key: ProductNames.SalesGas,
    showWhenKind: [ArpsDesignerKind.TypeWell]
  },
  {
    label: "Water",
    key: ProductNames.Water
  },
  {
    label: "Steam",
    key: ProductNames.Steam,
    showWhenBetaFeature: "Forecast Steam"
  },
  {
    type: "divider"
  },
  {
    label: ProductNames.OilPlusWater,
    key: ProductNames.OilPlusWater
  },
  {
    label: ProductNames.CGR,
    key: ProductNames.CGR
  },
  {
    label: ProductNames.GOR,
    key: ProductNames.GOR
  },
  {
    label: ProductNames.OGR,
    key: ProductNames.OGR
  },
  {
    label: ProductNames.WGR,
    key: ProductNames.WGR
  },
  {
    label: ProductNames.WOR,
    key: ProductNames.WOR
  },
  {
    label: ProductNames.OnePlusWOR,
    key: ProductNames.OnePlusWOR,
    showWhenKind: [ArpsDesignerKind.Forecasting]
  },
  {
    label: "C2 to Gas Ratio",
    key: ProductNames.C2,
    showWhenKind: [ArpsDesignerKind.Forecasting]
  },
  {
    label: "C3 to Gas Ratio",
    key: ProductNames.C3,
    showWhenKind: [ArpsDesignerKind.Forecasting]
  },
  {
    label: "C4 to Gas Ratio",
    key: ProductNames.C4,
    showWhenKind: [ArpsDesignerKind.Forecasting]
  },
  {
    label: "C5+ to Gas Ratio",
    key: ProductNames.C5,
    showWhenKind: [ArpsDesignerKind.Forecasting]
  },
  {
    label: ProductNames.SOR,
    key: ProductNames.SOR,
    showWhenBetaFeature: "Forecast Steam"
  },
  {
    label: "Shrinkage",
    key: ProductNames.Shrinkage,
    showWhenKind: [ArpsDesignerKind.Forecasting, ArpsDesignerKind.TypeWell]
  }
] as {
  label: string;
  type?: string;
  key: string;
  showWhenKind?: ArpsDesignerKind[];
  showWhenBetaFeature?: "Forecast Steam";
}[];

export const typeWellProductsMenuItems = (
  kind: ArpsDesignerKind,
  hasForecastLiquidProducts?: boolean,
  hasForecastSteam?: boolean
): TypeWellProductItem[] =>
  typeWellAndForecastProducts
    .filter((item) => {
      // Filter by beta feature first
      if (item.showWhenBetaFeature === "Forecast Steam" && !hasForecastSteam) {
        return false;
      }

      // Then filter by kind
      if (!item.showWhenKind) return true;
      if (item.showWhenKind.includes(kind)) return true;
      return (
        hasForecastLiquidProducts &&
        item.showWhenKind.includes(ArpsDesignerKind.Forecasting)
      );
    })
    .map((item) => {
      return {
        label: item.label,
        key: item.key,
        ...(item.type && { type: item.type })
      };
    });
